<template>
  <LoadingSpinner :loading='loading'> </LoadingSpinner>

  <div class="container mt-4 mb-4">
    <div style="max-width:560px">
        <h3>Kassasystembutikk VIVA-konto</h3>
        <div class="mt-2" style="font-style: italic; color:#666">
          <span>CAGISTAs <strong>egen</strong> VIVA-konto for kassasystembutikken (POS-shop) — brukes til å ta betalt fra kjøpere for utstyr, med CAGISTA som selger. Lagres som SYSTEM / DEVICE_STORE. Dette er ikke en merchants konto, og ikke ISV-oppsettet: abonnement trekkes fortsatt via Dintero.</span>
        </div>
        <div v-if='updated'>
          <span class='message-info'>VIVA-kontoen for kassasystembutikken er oppdatert</span>
        </div>

        <config-lock ref="lock" :configured="isConfigured">
        <div class="mt-4">
          <span class='ingredient-title'>merchantId (VIVA-kontoens id)</span>
          <input class='form-control' type='text' v-model='vivaAccount.merchantId' />
        </div>

        <div>
          <span class='ingredient-title'>apiKey (for refusjon — VIVAs legacy-API)</span>
          <input class='form-control' type='password' autocomplete='new-password' v-model='vivaAccount.apiKey' />
          <div class="text-muted small mt-1">
            Refusjon går mot et annet VIVA-API enn betalingen, med Basic-auth
            <code>merchantId:apiKey</code> — client_id/secret virker ikke der. Uten denne kan ordrer betales,
            men ikke refunderes.
          </div>
        </div>

        <div>
          <span class='ingredient-title'>client_id (Smart Checkout, CAGISTAs egen konto)</span>
          <input class='form-control' type='text' v-model='vivaAccount.clientId' />
        </div>

        <div>
          <span class='ingredient-title'>client_secret</span>
          <input class='form-control' type='password' autocomplete='new-password' v-model='vivaAccount.clientSecret' />
        </div>

        <div>
          <span class='ingredient-title'>sourceCode (valgfritt — betalingskilde med retur-URL)</span>
          <input class='form-control' type='text' v-model='vivaAccount.sourceCode' />
          <div class="text-muted small mt-1">
            Kilden bærer retur-adressen VIVA sender kjøperen tilbake til (<code>/store/return</code>).
            Uten den brukes kontoens standardkilde.
          </div>
        </div>

        <div v-if="!panelHr" class="bo_hr mt-4">
          <hr/>
        </div>

        <div class='mb-5'>
          <button v-if='activateSaveButton' type='button' class='bo_btn' @click='save'> Lagre </button>
          <button v-else type='button' class='bo_btn' @click='save' disabled='true'> Lagre </button>
        </div>
        </config-lock>
    </div>
  </div>
</template>

<script>
  import SettingsService from '@/services/settings/SettingsService';
  import LoadingSpinner from "@/components/other/LoadingSpinner";
  import ConfigLock from "@/components/other/ConfigLock";

  // CAGISTA's OWN VIVA account for the DEVICE STORE. Stored under the platform-global sentinel
  // merchant="SYSTEM" / locationId="DEVICE_STORE" (NOT the logged-in merchant). SUPER_ADMIN only — the
  // backend SecurityCheckInterceptor blocks non-SUPER_ADMIN from reading/writing SYSTEM data.
  //
  // This is CAGISTA selling hardware on its own account, which is why it carries its own
  // clientId/clientSecret: StoreVivaService authenticates AS this account against the plain
  // /checkout/v2/orders. That is a different thing from the ISV setup a merchant is onboarded into,
  // where CAGISTA's partner token acts on behalf of a connected account that has no credentials at all —
  // do not fill these in from VIVA Partner Config.
  //
  // The pair was the device store's Dintero account until the store moved to VIVA; subscription billing
  // now lives at SYSTEM / SUBSCRIPTION instead.
  export default {
    components: {LoadingSpinner, ConfigLock},
    data() {
      return {
        loading: true,
        updated: false,
        panelHr: false,
        vivaAccount: {
          type: "viva_account",   // DocumentType.VIVA_ACCOUNT — the literal Couchbase value
          merchant: 'SYSTEM',
          locationId: 'DEVICE_STORE',
          merchantId: '',
          apiKey: '',
          clientId: '',
          clientSecret: '',
          sourceCode: ''
        }
      };
    },
    mounted() {
      this.getVivaAccount();
    },
    computed: {
      // What StoreVivaService.isConfigured() actually requires: it authenticates with the client pair,
      // so those two are what decide whether the store can take a payment.
      activateSaveButton(){
        return this.vivaAccount.clientId.length > 0 && this.vivaAccount.clientSecret.length > 0;
      },
      // Already configured (→ starts locked): credentials were loaded from the server.
      isConfigured(){
        return !!(this.vivaAccount.clientId || this.vivaAccount.merchantId);
      }
    },
    methods: {
      getVivaAccount(){
        SettingsService.getStoreVivaAccount().then(
            (response) => {
              if(response.data !== null && response.data !== ""){
                this.vivaAccount = response.data;
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      },
      save(){
        this.loading = true;
        // Re-asserted on every save: this document IS the sentinel pair, and a page that let them drift
        // would write an account nothing reads.
        this.vivaAccount.type = 'viva_account';
        this.vivaAccount.merchant = 'SYSTEM';
        this.vivaAccount.locationId = 'DEVICE_STORE';

        SettingsService.editVivaAccount(this.vivaAccount).then(
            (response) => {
              let documentId = response.data;
              this.vivaAccount.id = documentId;
              if(documentId){
                this.updated = true;
                this.$refs.lock.relock();   // re-lock after a successful save
              } else {
                console.log("Editing the device-store vivaAccount failed");
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      }
    }
  };
</script>
